import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'

const DialogError = (props) => {
  const { title, description, closeButton, isOpen } = props

  return (
    <Dialog open={isOpen} maxWidth="xs">
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>{closeButton}</DialogActions>
    </Dialog>
  )
}

export default DialogError
